









export default {
  name: "ErrorField",
  props: {
    errors: {
      type: Array as () => string[],
      required: true
    },
    tag: {
      type: String,
      default: "span"
    }
  }
};
